/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBattleResult.vue?vue&type=template&id=9f36512e&scoped=true"
import script from "./popBattleResult.vue?vue&type=script&lang=js"
export * from "./popBattleResult.vue?vue&type=script&lang=js"
import style0 from "./popBattleResult.vue?vue&type=style&index=0&id=9f36512e&prod&lang=css"
import style1 from "./popBattleResult.vue?vue&type=style&index=1&id=9f36512e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f36512e",
  null
  
)

export default component.exports